import { render, staticRenderFns } from "./ReturnDetailsModal.vue?vue&type=template&id=1c453496&scoped=true"
import script from "./ReturnDetailsModal.vue?vue&type=script&lang=js"
export * from "./ReturnDetailsModal.vue?vue&type=script&lang=js"
import style0 from "./ReturnDetailsModal.vue?vue&type=style&index=0&id=1c453496&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c453496",
  null
  
)

export default component.exports